import Fields from "./GanacheCalculatorFields";
import Result from "./GanacheCalculatorResult";
import Description from "./GanacheCalculatorDescription";
import Custom from "../customCalculator/CustomCalculatorFormContainer";
import calculate from "./calculate";

const GanacheCalculator = { Description, Fields, Result, Custom, calculate };

export default GanacheCalculator;
